import React, { Component } from "react";
import { Helmet } from "react-helmet";
import PageWrapper from "../../components/PageWrapper/PageWrapper";
import Loading from "../../components/Loading/Loading";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withRouter } from "react-router-dom";
import FilterableVideoList from "../../components/FilterableVideoList/FilterableVideoList";
import VotingCompleteModal from "../../components/VotingCompleteModal/VotingCompleteModal";
import VotingErrorModal from "../../components/VotingErrorModal/VotingErrorModal";
import ErrorPage from "../ErrorPage/ErrorPage";
import {castYourVoteTextPageUID, DefaultMetaTags} from "../../config";
import {withPrismic} from "../../components/Prismic/Prismic";

class CompetitionVote extends Component {
  state = {
    id: null,
    voted: false,
    error: false,
    fetchError: false
  };
  async componentDidMount() {
    try {
      const id = await this.props.methods.getCompetitionBySlug(this.props.slug);
      this.setState({ id });
    } catch (error) {
      this.setState({ fetchError: true });
    }
    if(!this.props.prismic) return null;
    this.getText();
  }

  submitVotes = async selectedVideos => {
    const { emailHash } = this.props;
    const { id } = this.state;
    // First check if this email has already has votes
    const hasVoted = await this.props.methods.checkIfVoted(id, emailHash);
    if (!hasVoted) {
      await this.props.methods.submitVotes(id, emailHash, selectedVideos);
      this.setState({
        voted: true
      });
    } else {
      this.setState({
        error: true
      });
    }
  };

  getText = (uid) => {
    this.props.prismic.getPageData(castYourVoteTextPageUID).then((content) => {
      this.setState({content: content || ''});
    });
  };

  render() {
    const { content } = this.state
    // We haven't finished loading the competition yet
    if (!this.state.id) return <Loading />;

    // Competition couldn't be found
    if (this.state.fetchError) {
      return <ErrorPage />;
    }

    // Competition exists but voting isn't open
    const invalidState =
      this.props.competitions[this.state.id].state !== "voting";
    if (invalidState) {
      return <ErrorPage />;
    }

    const competitionData = this.props.competitions[this.state.id];
    return (
      <PageWrapper context="competition-vote">
        <Helmet
          title={`Videos for Change | Vote in - ${competitionData.name}`}
        />
        <DefaultMetaTags title={`Videos for Change | Vote in - ${competitionData.name}`} />
        <div>
          <FilterableVideoList
            title="Finalists"
            videos={competitionData.videos}
            competitionSlug={this.props.competitions[this.state.id].url}
            votingMode
            submitVotes={this.submitVotes}
          />
        </div>
        {this.state.voted && (
          <VotingCompleteModal
            textBody={content && content.data && content.data.body}
            handleDismiss={() => {
              this.props.history.push(
                `/competition/${this.props.competitions[this.state.id].url}`
              );
            }}
          />
        )}
        {this.state.error && (
          <VotingErrorModal
            handleDismiss={() => {
              this.props.history.push(
                `/competition/${this.props.competitions[this.state.id].url}`
              );
            }}
          />
        )}
      </PageWrapper>
    );
  }
}

export default withRouter(withFirebase(withPrismic(CompetitionVote)));



// WEBPACK FOOTER //
// ./src/pages/CompetitionVote/CompetitionVote.js